import { TabValues } from '@/modules/1on1s/views/1on1Editor/types';
import { OneOnOneTabs } from '@/modules/1on1s/views/1on1s/types';

const adminRoutes = {};

const learnerRoutes = {
  oneOnOnes: () => '/1on1s',
  oneOnOneDetail: (id: string) => `/1on1s/${id}`,
  oneOnOneTabs: (tab: OneOnOneTabs) => `/1on1s/${tab}`,
  oneOnOneMeetingDetail: (id: string, meetingInstanceId: string) =>
    `/1on1s/${id}/${meetingInstanceId}`,
  oneOnOneMeetingDetailTab: (id: string, meetingInstanceId: string, tabId: TabValues) =>
    `/1on1s/${id}/${meetingInstanceId}/${tabId}`,
};

export { adminRoutes, learnerRoutes };
export default learnerRoutes;
